module.exports = __webpack_public_path__ + "static/media/informalblue.d137e898.svg";